<template>
    <section class="l-section l-section--main">
        <div
            class="l-container l-container--main l-container--horizontalPaddings"
        >
            <div class="l-row l-row--center">
                <div class="l-row__column l-row__column--7">
                    <h1 class="a-title">Resetuj hasło</h1>
                    <form
                        class="a-mobile o-form"
                        @submit.prevent="handleSubmit"
                    >
                        <div class="a-control o-form__group">
                            <label
                                class="a-label a-control__label"
                                for="userLogin"
                            >
                                Email
                            </label>
                            <input
                                class="a-control__input"
                                type="email"
                                v-model="email"
                                autocomplete="username"
                            />
                        </div>
                        <o-notifications
                            :is-static="true"
                            name="dashboard-reset-password-1"
                        />
                        <div class="o-form__buttons">
                            <div class="a-mobile__buttons">
                                <a-button
                                    class="a-button"
                                    @click="$router.push({ name: 'dashboard-login' })"
                                >
                                    Powrót
                                </a-button>
                                &nbsp;
                                <a-button
                                    class="a-button a-button--primary"
                                    :is-processing="authStatus === 'pending'"
                                    type="submit"
                                >
                                    Rozpocznij proces resetowania hasła
                                    <a-icon class="a-button__icon" icon="Right"/>
                                </a-button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            email: (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_EMAIL) ? process.env.VUE_APP_EMAIL : ''
        }
    },
    computed: {
        authStatus() {
            return this.$store.getters['users/status']
        }
    },
    methods: {
        handleSubmit() {
            this.$store.dispatch('users/resetPasswordStep1', {
                email: this.email
            }).then(response => {
                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: response,
                    limit: 0,
                    name: 'dashboard-reset-password-1'
                })
            }).catch(error => {
                if(error && error.response && error.response && error.response.data && error.response.data.message) {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: error.response.data.message,
                        limit: 0,
                        name: 'dashboard-login'
                    })
                }
            })
        }
    }
}
</script>
